import WidgetItem from './item.model.js';
const model = {
    name: 'Widget',
    properties: {
        items: { type: 'array', model: WidgetItem }, // TODO: >= 1
    },
};
export default model;
